<template>
  <div style="background: white;padding:20px;padding-right:10px;margin-bottom:20px;">
    <div style="display: flex;justify-content: space-between;margin-bottom:20px;">
      <div>修改记录</div>
    </div>
    <div v-if="clueInfoPlain" style="margin-top:20px;max-height: 80vh;overflow: scroll;" v-loading="loading">
      <div v-for="(plain,idx) in clueInfoPlain">
        <div style="margin-bottom: 16px;color:#a2a2a2;font-size:14px;">
          <div>{{idx+1}}. {{ plain.add_time }}，由<span style="font-weight: bolder;color:black;padding: 0 8px;">{{plain.user_name}}</span>{{actionName(plain)}}<span style="font-weight: bolder;color:black;padding-left:8px;" v-if="actionTarget(plain)">{{actionTarget(plain)}}</span>。</div>
          <div style="margin-left:2rem;margin-top: 8px;" v-if="plain.content" v-for="con in JSON.parse(plain.content)">
            修改了<span style="font-weight: bolder;color:black;padding-left:8px;">{{cols_mapper[con.key].split(':').at(0)}}</span> ，旧值为 "<span style="color:black;">{{con.old_value}}</span>"，新值为"<span style="color:black;">{{con.new_value}}</span>"。
          </div>

        </div>
      </div>
    </div>
    <el-empty v-else description="暂无数据"></el-empty>
  </div>
</template>

<script>

import {
  getclueInfo
} from '../../../api/api'

export default {
  name: "BusinessChangeLog.vue",
  props: ["clue_id","refreshCount"],
  components: {},
  data() {
    return {
      loading:false,
      clueInfoPlain: null,
      cols_mapper:{}
    }
  },
  async mounted() {
    this.refresh(false)
  },

  watch: {
    clue_id(){
      this.refresh()
    },
    refreshCount(){
      this.refresh()
    }

  },

  methods: {
    actionName(logInfo){
      let map = {
        "create":"创建",
        "summary":"添加了",
        "progress_plan":"添加了",
        "edit_info":"修改了"
      }
      return map[logInfo.type] ? map[logInfo.type] : ""
    },
    actionTarget(logInfo){
      let map = {
        "create":"",
        "summary":"成功或失败原因分析",
        "progress_plan":"现阶段进度及规划",
        "edit_info":"商机信息"
      }
      return map[logInfo.type] ? map[logInfo.type] : ""
    },
    async getData() {
      let postData = {
        clue_id: this.clue_id
      }
      let res = await getclueInfo(postData)
      let newVal = res.respData
      this.clueInfoPlain = newVal.log_res
      this.cols_mapper = newVal.cols_mapper
      this.loading = false
    },

    async refresh(loading = true) {
      this.loading = loading
      await this.getData()
    }
  }
}
</script>
<style lang="scss">
.el-row {
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  height: 200px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.plain-body {
  padding: 10px;

  .plain-header {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-bottom: 10px;

    .plain-img {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: gray;
      margin-right: 6px;
    }

    .plain-user-name {
      color: gray;
    }
  }

  .plain-content {
    color: black;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .plain-time {
    font-size: 10px;
    color: lightgrey;
  }
}

</style>

